export default __webpack_public_path__ + "static/media/logo-hub.85c6f1d3.svg";